/**
 * Central env access for Create React App.
 * Values are injected at build/start time from .env — restart `npm start` after any .env change.
 */
const readEnv = (key, fallback = "") => {
  const value = process.env[key];
  if (typeof value === "string") {
    const trimmed = value.trim();
    return trimmed || fallback;
  }
  return fallback;
};

export const env = {
  apiBaseUrl: readEnv("REACT_APP_API_BASE_URL"),
  apiUrl: readEnv("REACT_APP_API_URL"),
  oneSignalAppId: readEnv("REACT_APP_ONESIGNAL_APP_ID"),
  googleMapsApiKey: readEnv("REACT_APP_GOOGLE_MAPS_API_KEY"),
  mapplsAccessToken: readEnv("REACT_APP_MAPPLS_ACCESS_TOKEN"),
  mapplsAuth: readEnv("REACT_APP_MAPPLS_AUTH", "auth2"),
  razorpayKeyId: readEnv("REACT_APP_RAZORPAY_KEY_ID"),
  version: readEnv("REACT_APP_VERSION", "1.0.0"),
};
